import { Component, Inject } from '@angular/core';
import { ConsumerModel } from '../../models/consumerModel';
import { FormControl, Validators } from '@angular/forms';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-consumer-add-edit',
  templateUrl: './consumer-add-edit.component.html',
  styleUrl: './consumer-add-edit.component.css'
})
export class ConsumerAddEditComponent {
  submitted: boolean = false;
  consumer: ConsumerModel = new ConsumerModel();
  name = new FormControl('', [Validators.required]);
  email = new FormControl('', [Validators.email]);
  description = new FormControl('', []);
  uniqueKey = new FormControl('', [Validators.required]);

  constructor(public _restAPI: RestAPIService, private toast: ToastService, public dialogRef: MatDialogRef<ConsumerAddEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any){
    this._restAPI.loading  = false;
    this.consumer = JSON.parse(JSON.stringify(data.consumerModel));
    localStorage["applyConsumerFilterValue"] = 'true';
  }

  async ngOnInit(){
    this.uniqueKey.disable();
    if(!this.consumer.id) {
      this.getConsumerKey();
    }
  }
  
  closeDialog(): void {
    this.dialogRef.close(false);
  }

  getConsumerKey() {
    this._restAPI.loading  = true;
    this._restAPI.get<string>(environment.apiURL + 'api/consumer/newconsumerkey',{responseType: 'text' as 'json'}).subscribe({
        next: (data) => {
            this._restAPI.loading  = false;
            this.consumer.uniqueKey = data;
        },
        error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
    });
  }

  copyText(text: string, messageHeader: string){
    try{
      navigator.clipboard.writeText(text);
      this.toast.show(messageHeader +" copied to clipboard.")
    }catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.toast.show(messageHeader +" copied to clipboard.")
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    }
  }

  async saveConsumer() {
    if(!this.name.invalid && !this.email.invalid && !this.description.invalid && !this.uniqueKey.invalid){
      this._restAPI.loading  = true;
      let postData = {
          name: this.consumer.name,
          email: this.consumer.email,
          description: this.consumer.description,
          uniqueKey: this.consumer.uniqueKey
      };
      if (this.consumer.id != null && this.consumer.id.length > 0) {
        this._restAPI.put<string>(environment.apiURL + 'api/consumer/edit/' + this.consumer.id, postData).subscribe({
            next: (results) => {
              this._restAPI.loading  = false;
              this.dialogRef.close(true);
              this.toast.show("Consumer has been updated successfully");
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
      }
      else {
        this._restAPI.post<string>(environment.apiURL + 'api/consumer/add', postData).subscribe({
            next: (results) => {
              this._restAPI.loading  = false;
              this.dialogRef.close(true);
              this.toast.show("Consumer has been added successfully");
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
      }
    }
  }
}
